import { CircularProgress, Menu } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { HiSearch } from 'react-icons/hi';
import {
  PiCaretDown,
  PiCaretUp,
  PiCursor,
  PiForkKnifeLight,
  PiShoppingBag,
  PiTruckLight,
} from 'react-icons/pi';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import noTickets from 'src/assets/images/noTickets.svg';
import Sort from 'src/assets/images/SortAscending.svg';
import Tag from 'src/assets/images/Tag.svg';
import {
  addCurrentOrder,
  addCurrentUser,
} from 'src/redux/action/currentOrder.action';
import { fetchSales } from 'src/redux/action/sales.action';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { SalesOrder } from 'src/types/model';
import { toastAlert } from 'src/utils/toastAlert';
import Modal from '../modal';
import { PaymentStatusButton } from '../payment-status';
import Loader from '../loader';
import { kotBotPrint } from './kotbot';
import { BsArrowDownShort, BsArrowUpShort } from 'react-icons/bs';
import { FiChevronDown } from 'react-icons/fi';
import { CurrencyAmount } from 'src/containers/currency';

const StyledAccordion = styled(Accordion)({
  '&.Mui-expanded': {
    margin: '0 !important',
  },
});

export const NoTicket = () => (
  <div className="w-[313px] h-[99%] border-[2px] rounded-xl space-x-[20px] border-dashed border-[#949CC0]  ml-auto flex flex-col gap-6 justify-center items-center ">
    {' '}
    <img src={noTickets} alt="noTickets" />
    <p className="font-semibold font-Outfit text-[16px] leading-6 text-[#949CC0]">
      No open tickets to show
    </p>
  </div>
);

const Tickets: React.FC<{ orders: SalesOrder[]; type: string }> = ({
  orders,
  type,
}) => {
  const [filteredText, setFilteredText] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [filteredOrderType, setFilteredOrderType] = useState<string[]>([
    'dine_in',
    'takeaway',
    'delivery',
    'online_order',
  ]);
  const [filteredSortBy, setFilteredSortBy] = useState('createdUp');
  const [filterFloors, setFilterFloors] = useState('All');
  const [cancelLoading, setCancelLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentOrder, setCurrentOrder] = useState('');
  const [cancelReason, setCancelReason] = useState('');
  const [showOnlineOrders, setShowOnlineOrders] = useState(false);
  const [isBillLoading, setIsBillLoading] = useState<boolean>(false);
  const [KOTOrder, setKOTOrder] = useState<any>(null);
  const [BOTOrder, setBOTOrder] = useState<any>(null);

  const { users } = useSelector(
    ({ currentOrderData }: RootState) => currentOrderData
  );
  const { settingData } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );
  const businessName = settingData?.businessInfo?.name;
  const businessAddress = settingData?.businessInfo?.address;

  const { salesData, orderType } = useSelector(
    ({ salesData }: RootState) => salesData
  );
  const { floors } = salesData;

  // const filteredOrdersByOrderType = useMemo(() => {
  //   if (orders.length > 0) {
  //     const filteredOrders = orders.filter((order) =>
  //       filteredOrderType.includes(order.type)
  //     );
  //     // if (showOnlineOrders) {
  //     //   return filteredOrders.filter((order) => order.origin === 'website');
  //     // }
  //     return filteredOrders;
  //   } else {
  //     return [];
  //   }
  // }, [orders, filteredOrderType]);

  const filteredOrdersByOrderType = useMemo(() => {
    if (orders.length > 0) {
      const filteredOrders = orders.filter((order) => {
        if (
          (filteredOrderType.includes('dine_in') && order.type === 'dine_in') ||
          (filteredOrderType.includes('takeaway') &&
            order.type === 'takeaway') ||
          (filteredOrderType.includes('delivery') &&
            order.type === 'delivery' &&
            order.origin === 'pos_device') ||
          (filteredOrderType.includes('online_order') &&
            order.type === 'delivery' &&
            order.origin === 'website')
        ) {
          return true;
        }

        return false;
      });

      return filteredOrders;
    } else {
      return [];
    }
  }, [orders, filteredOrderType]);

  const filteredOrdersBySort = useMemo(() => {
    if (filteredOrdersByOrderType.length > 0) {
      if (filteredSortBy === 'createdUp') {
        return [...filteredOrdersByOrderType].sort((a, b) => {
          if (
            typeof a.createdAt === 'string' &&
            typeof b.createdAt === 'string'
          ) {
            return (
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );
          }
          return 0;
        });
      } else if (filteredSortBy === 'createdDown') {
        return [...filteredOrdersByOrderType].sort((a, b) => {
          if (
            typeof a.createdAt === 'string' &&
            typeof b.createdAt === 'string'
          ) {
            return (
              new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
            );
          }
          return 0;
        });
      } else if (filteredSortBy === 'amountUp') {
        // Sort by subTotal from highest to lowest
        return [...filteredOrdersByOrderType].sort((a, b) => {
          return b.subTotal - a.subTotal;
        });
      } else if (filteredSortBy === 'amountDown') {
        // Sort by subTotal from lowest to highest
        return [...filteredOrdersByOrderType].sort((a, b) => {
          return a.subTotal - b.subTotal;
        });
      } else {
        return filteredOrdersByOrderType;
      }
    } else {
      return [];
    }
  }, [filteredOrdersByOrderType, filteredSortBy]);

  const filteredOrdersByFloors = useMemo(() => {
    if (filteredOrdersBySort.length > 0) {
      if (filterFloors === 'All') {
        return filteredOrdersBySort;
      } else {
        return filteredOrdersBySort.filter(
          (order) => order?.table?.floorId === filterFloors
        );
      }
    } else {
      return [];
    }
  }, [filterFloors, filteredOrdersBySort]);

  const filteredTable = useMemo(() => {
    if (filteredOrdersByFloors.length > 0) {
      if (filteredText.trim().length > 0) {
        // const a = filteredOrdersByFloors.filter(
        //   (i) =>
        //     i.table &&
        //     i?.table?.name.toLowerCase().startsWith(filteredText.toLowerCase())
        // );
        const a = filteredOrdersByFloors.filter((i) =>
          i?.referenceNumber
            ?.split('-')[1]
            .startsWith(filteredText.toLowerCase())
        );
        return a;
      } else {
        return filteredOrdersByFloors;
      }
    } else {
      return [];
    }
  }, [filteredText, filteredOrdersByFloors]);

  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const [currentCancellingOrder, setCurrentCancellingOrder] = useState(
    Array(filteredTable?.length).fill(false)
  );
  const [paymentLoading, setPaymentLoading] = useState(
    Array(filteredTable?.length).fill(false)
  );

  const makePayment = async (id: string, ind: number) => {
    if (paymentLoading[ind]) {
      return;
    }
    const updatedPaymentLoading = [...paymentLoading];
    updatedPaymentLoading[ind] = true;
    setPaymentLoading(updatedPaymentLoading);
    const userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '');
    try {
      const data = await Service.get(`/orders/${id}`);
      const dataOrders = data?.data?.data?.order;
      const user = dataOrders?.customer?.id
        ? users.find((userInfo) => userInfo.id === dataOrders.customer.id)
        : null;
      const a = {
        businessId: userInfo?.businessInfo?.id,
        type: type,
        tableId: dataOrders?.table?.id,
        tableName: dataOrders?.table?.name,
        userId: dataOrders.customer ? dataOrders.customer.id : null,
        origin: dataOrders.origin,
        deliveryCharge: dataOrders.deliveryCharge,
        promo: dataOrders.promo || null,
        items:
          dataOrders.ordersItems.length > 0
            ? dataOrders.ordersItems.map((item: any) => {
                return {
                  itemId: item.itemId,
                  name: item.itemName,
                  variantId: item.variantId,
                  hasVariants: item.hasVariants,
                  variantName: item.variantName,
                  identifierId: item.id,
                  quantity: item.quantity,
                  spiceLevel: item.spiceLevel || null,
                  selectedModifiers: item.allModifiers.map((modifier: any) => {
                    const optionsWithSelected = modifier.options.map(
                      (option: any) => {
                        const optionInModifiers = item.modifiers
                          .find((mod: any) => mod.id === modifier.id)
                          ?.options.find((op: any) => op.id === option.id);
                        return {
                          id: option.id,
                          price: option.price,
                          name: option.name,
                          hasSelected: !!optionInModifiers,
                        };
                      }
                    );
                    return {
                      id: modifier.id,
                      options: optionsWithSelected,
                    };
                  }),
                  price: item.discountedPrice || item.price,
                  note: item?.note || '',
                };
              })
            : [],
      };
      if (dataOrders.ordersItems.length > 0) {
        dispatch(addCurrentOrder({ ...a }));
        navigate('/payment', { state: { orderId: id } });
        if (user) {
          dispatch(
            addCurrentUser({
              id: user.id,
              name: user.name,
              email: user?.email || null,
              phone: parseFloat(user?.phone),
              image: user?.image || null,
            })
          );
        }
      }
      const updatedPaymentLoading = [...paymentLoading];
      updatedPaymentLoading[ind] = false;
      setPaymentLoading(updatedPaymentLoading);
    } catch (err: any) {
      toastAlert('error', err.message);
      const updatedPaymentLoading = [...paymentLoading];
      updatedPaymentLoading[ind] = false;
      setPaymentLoading(updatedPaymentLoading);
    }
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOrderTypeClick = (type: string) => {
    if (filteredOrderType.includes(type)) {
      const updatedFilter = filteredOrderType.filter((item) => item !== type);
      setFilteredOrderType(updatedFilter);
    } else {
      const updatedFilter = filteredOrderType.concat(type);
      setFilteredOrderType(updatedFilter);
    }
  };

  const handleSortByClick = (name: string) => {
    if (filteredSortBy === name) {
      setFilteredSortBy('');
    } else {
      setFilteredSortBy(name);
    }
  };

  const handleChangeStatus = async (id: string) => {
    const data = {
      id: id,
      newStatus: 'preparing',
    };
    try {
      await Service.post(`/orders/status`, data);
      dispatch(fetchSales() as any);
    } catch (err: any) {}
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentCancellingOrder((order) => order.map((i) => false));
    setCurrentOrder('');
    setCancelReason('');
  };

  const cancelOrder = async (id: string) => {
    if (!id || cancelLoading) {
      return;
    }
    if (cancelReason.trim() === '') {
      toastAlert('error', 'Provide reason for cancellation');
      handleCloseModal();
      return;
    }
    const data = {
      id: id,
      newStatus: 'canceled',
      cancelledReason: cancelReason,
    };
    setShowModal(false);
    setCancelLoading(true);
    handleCloseModal();
    try {
      await Service.post('/orders/status', data);
      toastAlert('success', `Order cancelled successfully`);
      navigate('/dine-in');
      setCancelLoading(false);
      dispatch(fetchSales() as any);
    } catch (err: any) {
      toastAlert('error', err.message);
      setCancelLoading(false);
    }
  };

  /* eslint-disable react/prop-types */
  // const kotPrint = (props: SalesOrder) => {
  //   return (
  //     <div>
  //       <div
  //         id={`startprintKOT${props.id}`}
  //         className="hidden"
  //         style={{ fontFamily: 'Arial' }}
  //       >
  //         <div
  //           className="w-[85%] h-[100%]"
  //           style={{
  //             display: 'flex',
  //             flexDirection: 'column',
  //             fontFamily: 'Arial',
  //             fontWeight: '400',
  //           }}
  //         >
  //           <div
  //             style={{
  //               display: 'flex',
  //               flexDirection: 'column',
  //               alignItems: 'center',
  //             }}
  //           >
  //             <span
  //               style={{
  //                 fontSize: '16px',
  //                 lineHeight: '18px',
  //                 marginBottom: '5px',
  //               }}
  //             >
  //               KOT
  //             </span>
  //           </div>
  //           <span
  //             style={{
  //               display: 'flex',
  //               justifyContent: 'space-between',
  //               marginTop: '10px',
  //               fontSize: '12px',
  //               lineHeight: '14px',
  //               marginBottom: '5px',
  //             }}
  //           >
  //             <span> Order No: #{props?.referenceNumber?.split('-')[1]}</span>
  //             <span> {moment(props?.createdAt).format('MM/DD/YYYY')}</span>
  //           </span>
  //           <span
  //             style={{
  //               display: 'flex',
  //               justifyContent: 'space-between',
  //               fontSize: '12px',
  //               lineHeight: '14px',
  //               marginBottom: '5px',
  //             }}
  //           >
  //             <span>
  //               {' '}
  //               {props.type === 'takeaway' && <>Takeaway</>}
  //               {props.type === 'dine_in' && <>Table- {props?.table?.name}</>}
  //               {props.type === 'delivery' && <>Delivery</>}
  //             </span>
  //             <span> {moment(props?.createdAt).format('h:mm A')}</span>
  //           </span>

  //           <div
  //             style={{
  //               margin: '10px 0',
  //               borderTop: '2px solid #000',
  //             }}
  //           />

  //           {props?.ordersItems?.map((item) => {
  //             return (
  //               <div key={item.id}>
  //                 <div
  //                   style={{
  //                     display: 'flex',
  //                     flexDirection: 'column',
  //                     fontSize: '12px',
  //                     lineHeight: '14px',
  //                     marginBottom: '15px',
  //                   }}
  //                 >
  //                   <div>
  //                     <span>{item.quantity}</span>
  //                     <span style={{ marginLeft: '5px' }}>
  //                       {item.hasVariants
  //                         ? `${item.itemName}(${item.variantName})`
  //                         : `${item.itemName}`}{' '}
  //                     </span>
  //                   </div>
  //                   {item?.modifiers?.length > 0 ? (
  //                     <>
  //                       {item.modifiers.map((mod) => (
  //                         <div key={mod.id}>
  //                           {mod.options.map((option: any) => (
  //                             <div
  //                               key={option.id}
  //                               style={{
  //                                 marginLeft: '10px',
  //                                 marginTop: '5px',
  //                               }}
  //                             >
  //                               <span>{option.name}</span>
  //                             </div>
  //                           ))}
  //                         </div>
  //                       ))}
  //                     </>
  //                   ) : (
  //                     <></>
  //                   )}

  //                   {item?.spiceLevel !== null && item.spiceLevel !== 'No' ? (
  //                     <>
  //                       <div
  //                         style={{
  //                           display: 'flex',
  //                           justifyContent: 'space-between',
  //                           marginLeft: '10px',
  //                           marginTop: '5px',
  //                         }}
  //                       >
  //                         <span>Spice level</span>
  //                         <span>{item.spiceLevel}</span>
  //                       </div>
  //                     </>
  //                   ) : (
  //                     <></>
  //                   )}

  //                   {item.note !== null && item.note ? (
  //                     <div
  //                       style={{
  //                         display: 'flex',
  //                         flexDirection: 'column',
  //                         marginLeft: '10px',
  //                         marginTop: '5px',
  //                       }}
  //                     >
  //                       <span
  //                         style={{
  //                           fontWeight: '700',
  //                           fontSize: '12px',
  //                           lineHeight: '16px',
  //                           color: '#6D6D6D',
  //                         }}
  //                       >
  //                         Note:{' '}
  //                       </span>
  //                       <span
  //                         style={{
  //                           fontWeight: '400',
  //                           fontSize: '12px',
  //                           lineHeight: '18px',
  //                           color: '#6D6D6D',
  //                         }}
  //                       >
  //                         {item?.note}
  //                       </span>
  //                     </div>
  //                   ) : (
  //                     <></>
  //                   )}
  //                 </div>
  //               </div>
  //             );
  //           })}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const handlePrintKOT = (id: any) => {
    const prtContent = document.getElementById(`startprintKOT${id}`);
    if (!prtContent) return;
    const printWindow = window.open(
      '',
      '',
      'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0'
    );
    if (printWindow) {
      printWindow.document.write(prtContent.innerHTML);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    } else {
      console.error('Failed to open a new window for printing.');
    }
  };

  const handleFinishCooking = async (
    thisOrder: any,
    index: number,
    status: string
  ) => {
    var send_data = {
      id: thisOrder.id,
      newStatus: status,
    };
    const res: any = await Service.post('/orders/status', send_data);
    if (status === 'ready_for_delivery') {
      toastAlert('success', 'Cooking completed');
      setExpandedIndex(null);
    }
    if (res.error) {
      toastAlert('error', res.message);
    }
  };

  const getBill = async (order: any) => {
    setIsBillLoading(true);
    const res: any = await Service.get(`orders/printTypes/${order.id}`);
    orders = res.data?.printTypes || [];
    const kot = orders.find((order) => order.title === 'KOT');
    const bot = orders.find((order) => order.title === 'BOT');
    setKOTOrder(kot);
    setBOTOrder(bot);
    setIsBillLoading(false);
  };

  if (orders?.length > 0) {
    return (
      <div className="w-[334px]  rounded-xl  ml-auto flex flex-col gap-4 items-center  ">
        <div className=" flex flex-row gap-4 items-center ">
          <div className="relative flex items-center w-[274px] h-[41px]">
            <input
              type="text"
              placeholder="Search orders"
              className="pr-9 flex-1 w-full px-4 py-2 border border-[#CACFE3] rounded-full focus:outline-none "
              onChange={(e) => {
                setFilteredText(e.target.value);
              }}
            />
            <div className="absolute right-3">
              <HiSearch
                className="text-gray-400"
                style={{ fontSize: '20px' }}
              />
            </div>
          </div>
          <button
            className="w-[32] h-[32] cursor-pointer"
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <img src={Sort} alt="sort" />
          </button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            PaperProps={{
              style: {
                boxShadow: 'none',
                border: '1px solid #F1F0F6',
                width: '290px',
                height: 'fit',
                maxHeight: '290px',
                backgroundColor: '#FFFFFF',
                padding: '10px 16px',
                marginTop: '10px',
                overflow: 'hidden',
              },
            }}
          >
            <div className="w-full flex flex-col gap-3 ">
              <div className="flex flex-col">
                <div className="font-Outfit font-normal mb-2 text-xs leading-[18px] text-[#7F8397]">
                  Order Type
                </div>
                <div className="flex flex-wrap gap-2 ">
                  {orderType?.dine_in && (
                    <div
                      className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit text-xs leading-[18px] ${
                        filteredOrderType.includes('dine_in')
                          ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                          : 'border-[#CACFE3] font-normal text-[#7F8397] '
                      }`}
                      onClick={() => handleOrderTypeClick('dine_in')}
                    >
                      Dine In
                    </div>
                  )}
                  {orderType?.takeaway && (
                    <div
                      className={`flex  cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                        filteredOrderType.includes('takeaway')
                          ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                          : 'border-[#CACFE3] font-normal text-[#7F8397] '
                      } `}
                      onClick={() => handleOrderTypeClick('takeaway')}
                    >
                      Takeaway
                    </div>
                  )}
                  {orderType?.delivery && (
                    <div
                      className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit text-xs leading-[18px] ${
                        filteredOrderType.includes('delivery')
                          ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                          : 'border-[#CACFE3] font-normal text-[#7F8397] '
                      }`}
                      onClick={() => handleOrderTypeClick('delivery')}
                    >
                      Delivery
                    </div>
                  )}
                  {orderType?.online_order && (
                    <div
                      className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px]  ${
                        filteredOrderType.includes('online_order')
                          ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                          : 'border-[#CACFE3] font-normal text-[#7F8397] '
                      } `}
                      onClick={() => {
                        handleOrderTypeClick('online_order');
                        setShowOnlineOrders((a) => !a);
                      }}
                    >
                      Online
                    </div>
                  )}
                </div>
              </div>
              <div className="flex flex-col">
                <div className="font-Outfit font-normal mb-2 text-xs leading-[18px] text-[#7F8397]">
                  Sort by
                </div>
                <div className="flex flex-wrap gap-2 ">
                  <div
                    className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                      filteredSortBy === 'createdUp'
                        ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                        : 'border-[#CACFE3] font-normal text-[#7F8397] '
                    }`}
                    onClick={() => handleSortByClick('createdUp')}
                  >
                    Created <BsArrowUpShort fontSize={18} />
                  </div>
                  <div
                    className={`flex  cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                      filteredSortBy === 'createdDown'
                        ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                        : 'border-[#CACFE3] font-normal text-[#7F8397] '
                    }`}
                    onClick={() => handleSortByClick('createdDown')}
                  >
                    Created <BsArrowDownShort fontSize={18} />
                  </div>
                  <div
                    className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                      filteredSortBy === 'amountUp'
                        ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                        : 'border-[#CACFE3] font-normal text-[#7F8397] '
                    }`}
                    onClick={() => handleSortByClick('amountUp')}
                  >
                    Amount <BsArrowUpShort fontSize={18} />
                  </div>
                  <div
                    className={`flex cursor-pointer h-[26px] w-[78px] items-center border justify-center rounded-[5px]  font-Outfit  text-xs leading-[18px] ${
                      filteredSortBy === 'amountDown'
                        ? ' border-[#4062FF] font-semibold text-[#4062FF]'
                        : 'border-[#CACFE3] font-normal text-[#7F8397] '
                    } `}
                    onClick={() => handleSortByClick('amountDown')}
                  >
                    Amount <BsArrowDownShort fontSize={18} />
                  </div>
                </div>
              </div>
              <div className="flex flex-col">
                <div className="font-Outfit font-normal mb-2 text-xs leading-[18px] text-[#7F8397]">
                  Filter floors
                </div>
                <div className="relative">
                  <select
                    className="w-full h-[36px] rounded-xl border outline-none cursor-pointer border-[#CACFE3] appearance-none px-[20px] font-Outfit font-normal text-xs"
                    value={filterFloors}
                    onChange={(event) => {
                      setFilterFloors(event.target.value);
                    }}
                  >
                    <option value="All">All</option>
                    {floors?.map((floor: any) => (
                      <option key={floor.id} value={floor.id}>
                        {floor.name}
                      </option>
                    ))}
                  </select>
                  <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                    <FiChevronDown className="text-gray-400" />
                  </div>
                </div>
              </div>
            </div>
          </Menu>
        </div>

        {filteredTable.length === 0 && <div>No table found.</div>}

        <div className="w-[322px] flex flex-col h-full overflow-y-scroll gap-3  ">
          {' '}
          {filteredTable?.map((order, index) => {
            let promoAmount = 0;
            if (order?.promo) {
              if (order.promo?.type === 'percent') {
                promoAmount = 
                  (order.promo.value / 100) * order.subTotal
              }
              if (order.promo?.type === 'amount') {
                promoAmount = (order.promo.value);
              }
            }

            let totalTaxAmount = 0;
            if (order.taxes.length > 0) {
              totalTaxAmount = order.taxes.reduce((acc, tax) => {
                if (tax.type === 'percent') {
                  return acc + ((tax.value / 100) * order.subTotal);
                } else if (tax.type === 'amount') {
                  return acc + tax.value;
                }
                return acc;
              }, 0);
            }

            return (
              <StyledAccordion
                key={index}
                className="w-full border py-3 px-4 border-[#CACFE3]  rounded-xl flex flex-col gap-[6px] "
                style={{
                  borderRadius: '12px',
                  boxShadow: 'none',
                }}
                sx={{
                  '&:before': {
                    display: 'none',
                  },
                }}
                expanded={index === expandedIndex}
              >
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{
                    padding: '0',
                    maxHeight: '78px',
                  }}
                  onClick={() => {
                    getBill(order);
                    setExpandedIndex(expandedIndex === index ? null : index);
                  }}
                >
                  <div className="w-full h-fit  flex flex-col gap-[6px] ">
                    <div className="h-[22px] flex justify-between items-center w-full">
                      <div className="flex gap-2">
                        {order.type === 'dine_in' && (
                          <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                            <PiForkKnifeLight color="#7F8397" />
                          </div>
                        )}
                        {order.type === 'takeaway' && (
                          <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                            <PiShoppingBag color="#7F8397" />
                          </div>
                        )}
                        {order.type === 'delivery' && (
                          <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                            <PiTruckLight color="#7F8397" />
                          </div>
                        )}
                        {order.type === 'online_order' && (
                          <div className="flex justify-center items-center w-[22px] h-[22px] rounded-[5px] border border-[#CACFE3]">
                            <PiCursor color="#7F8397" />
                          </div>
                        )}
                        <div
                          className={`w-fit px-2 uppercase  bg-opacity-20 h-[22px] flex items-center justify-center rounded-[5px]  font-Outfit font-normal text-[12px] leading-[18px] ${
                            order.status === 'preparing'
                              ? 'text-[#4062FF] bg-[#4062FF] border-none'
                              : order.status === 'dispatched'
                              ? 'text-[#FEC02D] bg-[#FEC02D] border-none'
                              : order.status === 'cooking'
                              ? 'text-success bg-success border-none'
                              : order.status === 'new'
                              ? 'text-[#7F8397] bg-[#7F839733]'
                              : order.status === 'failed' ||
                                order.status === 'canceled'
                              ? 'text-[#E22B41] bg-[#E22B41] border-none'
                              : order.status === 'delivered'
                              ? 'text-[#0BC988] bg-[#0BC988] border-none'
                              : order.status === 'completed'
                              ? 'text-[#2B2B2B] bg-[#2B2B2B]'
                              : 'text-[#7F839733] bg-[#7F839733]'
                          }`}
                        >
                          {order.status}
                        </div>

                        {order.origin === 'website' && (
                          <div className="w-[49px] h-[22px] flex items-center justify-center rounded-[5px] border border-[#CACFE3] font-Outfit font-normal text-[#7F8397] text-[12px] leading-[18px]">
                            WEB
                          </div>
                        )}
                        {order.origin === 'pos_device' && (
                          <div className="w-[49px] h-[22px] flex items-center justify-center rounded-[5px] border border-[#CACFE3] font-Outfit font-normal text-[#7F8397] text-[12px] leading-[18px]">
                            POS
                          </div>
                        )}
                        {order.origin === 'customer_app' && (
                          <div className="w-[49px] h-[22px] flex items-center justify-center rounded-[5px] border border-[#CACFE3] font-Outfit font-normal text-[#7F8397] text-[12px] leading-[18px]">
                            APP
                          </div>
                        )}
                        {PaymentStatusButton(order.paymentStatus)}
                      </div>
                      {expandedIndex === index ? (
                        <PiCaretUp />
                      ) : (
                        <PiCaretDown />
                      )}
                    </div>
                    <div className="w-full h-[24px] flex justify-between items-center ">
                      <div className="font-Outfit font-semibold text-[16px] leading-6 ">
                        {order.type === 'takeaway' && (
                          <>Takeaway- {order?.referenceNumber}</>
                        )}
                        {order.type === 'dine_in' && (
                          <>
                            Table- {order?.table?.name} ({order.referenceNumber}
                            )
                          </>
                        )}
                        {order.type === 'delivery' && (
                          <>Delivery- {order?.referenceNumber}</>
                        )}
                      </div>

                    </div>
                    <div className="w-full h-[18px] flex justify-between items-center ">
                      <div className="font-Outfit font-normal text-[12px] leading-[18px] text-[#949CC0]">
                        by {order.employee ? order?.employee?.name : 'owner'}
                      </div>
                      <div className="font-Outfit font-normal text-[12px] leading-[18px] text-[#949CC0]">
                        {/* {moment(order?.createdAt).fromNow()} */}
                        {moment(order?.createdAt).format('YYYY-MM-DD h:mm A')}
                      </div>
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    padding: '0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                  }}
                >
                  {order?.ordersItems.map((item, i) => {
                    let priceWithModifiers = 0;

                    if (item.modifiers.length > 0) {
                      item.modifiers.forEach((a) => {
                        a.options.forEach((b: any) => {
                          priceWithModifiers += b.price;
                        });
                      });
                    }

                    return (
                      <div
                        key={i}
                        className={` pb-1 ${
                          i !== order.ordersItems.length - 1
                            ? 'border-b border-[#F1F0F6]'
                            : ''
                        }`}
                      >
                        <div className="w-full min-h-[24px] h-fit flex justify-between items-center ">
                          <div className="font-Outfit font-semibold text-[16px] leading-6 flex items-center gap-[5px]">
                            <div className="w-fit max-w-[150px] break-words">
                              {item?.hasVariants
                                ? `${item?.itemName}(${item?.variantName})`
                                : `${item?.itemName}`}
                            </div>
                            <img src={Tag} alt="Tag" />
                            <span>x{item?.quantity}</span>
                          </div>

                          <div className="font-Outfit font-normal text-[16px] leading-6">
                           {(
                              (item?.unitDiscountedPrice + priceWithModifiers) *
                                item?.quantity
                              )|| '-'}
                          </div>
                        </div>
                        {item?.modifiers?.length > 0 ? (
                          <>
                            {item.modifiers.map((mod) => (
                              <div key={mod.id}>
                                {mod.options.map((option: any) => (
                                  <div
                                    key={option.id}
                                    className="w-full h-[21px] flex justify-between items-center"
                                  >
                                    <div className="font-Outfit font-normal text-[14px] leading-[21px] text-[#949CC0]">
                                      {option.name}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))}
                          </>
                        ) : (
                          <></>
                        )}

                        {item?.spiceLevel !== null &&
                        item.spiceLevel !== 'No' ? (
                          <>
                            <div className="w-full h-[21px] flex justify-between items-center">
                              <div className="font-Outfit font-normal text-[14px] leading-[21px] text-[#949CC0]">
                                Spice level
                              </div>
                              <div className="font-Outfit font-normal text-[14px] leading-[21px] text-[#949CC0]">
                                {item?.spiceLevel}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        {item?.note ? (
                          <>
                            <div className="w-full h-fit flex flex-col justify-between items-start">
                              <div className="w-full font-Sarabun font-normal italic text-[14px] h-fit leading-[21px] text-[#7F8397] break-words">
                                Note: {item?.note}
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    );
                  })}

                  <div className="w-full h-[41px] gap-2 flex justify-between items-center ">
                    <div
                      className="w-[141px] h-[41px] ml-auto  flex justify-center bg-[#4062FF] text-[#FFFFFF] items-center rounded-lg cursor-pointer font-Outfit font-semibold text-[15px] leading-5"
                      onClick={(e) => {
                        handleFinishCooking(order, index, 'ready_for_delivery');
                      }}
                    >
                      Finish Cooking
                    </div>
                    <div
                      className="w-[141px] h-[41px] ml-auto  flex justify-center bg-[#4062FF] text-[#FFFFFF] items-center rounded-lg cursor-pointer font-Outfit font-semibold text-[15px] leading-5"
                      onClick={(e) => {
                        if (KOTOrder) handlePrintKOT(order.id + 'KOT');
                        if (BOTOrder) handlePrintKOT(order.id + 'BOT');
                        handleFinishCooking(order, index, 'cooking');
                      }}
                    >
                      {isBillLoading ? (
                        <div className="bg-red-500 flex justify-center py-4">
                          <CircularProgress
                            size={20}
                            style={{ color: '#fff' }}
                          />
                        </div>
                      ) : KOTOrder && BOTOrder ? (
                        'Print KOT/BOT'
                      ) : KOTOrder ? (
                        'Print KOT'
                      ) : BOTOrder ? (
                        'Print BOT'
                      ) : (
                        'Print'
                      )}
                    </div>
                  </div>
                </AccordionDetails>
                {KOTOrder && kotBotPrint(KOTOrder)}
                {BOTOrder && kotBotPrint(BOTOrder)}
                {currentCancellingOrder[index] && showModal && (
                  <Modal
                    title="Reason for Cancellation?"
                    onClick={(e: any) => handleCloseModal()}
                    modalSize="30"
                  >
                    <div className="mx-5">
                      <div className="mb-6">
                        <textarea
                          className="border-[1px] w-full border-light-gray rounded-xl px-1 py-2 focus:border-[1px] focus:border-primary-200 mt-3 focus:shadow-none focus:ring-0 focus:outline-none text-sm  text-[#2B2B2B] font-Outfit"
                          rows={5}
                          cols={42}
                          value={cancelReason}
                          onChange={(e) => {
                            setCancelReason(e.target.value);
                          }}
                        />
                      </div>
                      <div className="flex flex-row justify-end gap-6 items-center w-full">
                        <div
                          className="font-Sarabun font-semibold text-base text-primary cursor-pointer"
                          onClick={(e) => handleCloseModal()}
                        >
                          Cancel
                        </div>
                        <button
                          className="bg-primary text-pure-white w-[150px] h-[41px] flex justify-center items-center font-Outfit font-semibold text-sm rounded-lg"
                          type="submit"
                          onClick={(e: any) => {
                            cancelOrder(order.id);
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </Modal>
                )}
              </StyledAccordion>
            );
          })}
        </div>
      </div>
    );
  }

  if (orders.length === 0) {
    return <NoTicket />;
  }

  return null;
};

export default React.memo(Tickets);
